module.exports = __webpack_public_path__ + "img/exercicios1.2dccaabe.png";